import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { bindPopover, usePopupState } from 'material-ui-popup-state/hooks';

import { ConnectionHistoryFilterSchema } from './connection-history-filter.schema';
import { ConnectionHistoryFilterFormValues } from './connection-history-filter.types';
import { connectionHistoryFilterToGqlFilter } from './connection-history-filter.utils';

export const useLocationConnectionHistoryFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const filterFormValues = useMemo(() => {
    const input: Record<string, unknown> = Object.fromEntries(searchParams.entries());
    if (searchParams.has('disconnectActionContains')) {
      input.disconnectActionContains = searchParams.getAll('disconnectActionContains');
    }
    const filter = ConnectionHistoryFilterSchema.safeParse(input);
    if (filter.success) return filter.data;
    // TODO: handle invalid filter in a better way
    console.warn('Invalid filter from search params', filter.error.format());
    return {};
  }, [searchParams]);

  const queryFilter = useMemo(() => {
    return connectionHistoryFilterToGqlFilter(filterFormValues);
  }, [filterFormValues]);

  const popupState = usePopupState({ variant: 'popover', popupId: 'connection-history-filters' });
  const popoverProps = useMemo(() => {
    return {
      ...bindPopover({
        ...popupState,
      }),
    };
  }, [popupState]);

  return {
    queryFilter,
    isActive: Object.keys(filterFormValues).length > 0,
    value: filterFormValues,
    onChange: (nextFilters: ConnectionHistoryFilterFormValues) => {
      setSearchParams(nextFilters as any);
      popupState.close();
    },
    popoverProps,
    popupState,
  };
};
